import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faShoppingCart,
    faCommentAlt,
    faUserPlus,
    faCog,
    faFileMedical,
    faList,
    faUserCircle
} from '@fortawesome/free-solid-svg-icons';
import { faBuffer } from '@fortawesome/free-brands-svg-icons';
import { useAppContext } from '../../../context';

const Sidebar = ({ setTitle }) => {
    const { state: { admin } } = useAppContext();

    const navClass = ({ isActive }) => isActive ? "activePage" : "";

    return (
        <div>
            <div className="sideBrand">
                <div className="sideBrnIcon">
                    <FontAwesomeIcon icon={faBuffer} />
                </div>
                <h2>NextGen <span className="navHighlight">Nexus</span></h2>
            </div>

            <nav id="sideNavbar">
                <ul>
                    <li>
                        <NavLink onClick={() => setTitle('Profile')} className={navClass} to="/dashboard/profile">
                            <FontAwesomeIcon icon={faUserCircle} className="iconC" />
                            Profile
                        </NavLink>
                    </li>

                    {admin ? (
                        <>
                            <li>
                                <NavLink onClick={() => setTitle('Order List')} className={navClass} to="/dashboard/orderList">
                                    <FontAwesomeIcon icon={faList} className="iconC" />
                                    Order List
                                </NavLink>
                            </li>

                            <li>
                                <NavLink onClick={() => setTitle('Add Service')} className={navClass} to="/dashboard/addService">
                                    <FontAwesomeIcon icon={faFileMedical} className="iconC" />
                                    Add Service
                                </NavLink>
                            </li>

                            <li>
                                <NavLink onClick={() => setTitle('Make Admin')} className={navClass} to="/dashboard/makeAdmin">
                                    <FontAwesomeIcon icon={faUserPlus} className="iconC" />
                                    Make Admin
                                </NavLink>
                            </li>

                            <li>
                                <NavLink onClick={() => setTitle('Manage Services')} className={navClass} to="/dashboard/manageServices">
                                    <FontAwesomeIcon icon={faCog} className="iconC" />
                                    Manage Services
                                </NavLink>
                            </li>
                        </>
                    ) : (
                        <>
                            <li>
                                <NavLink onClick={() => setTitle('Book Service')} className={navClass} to="/dashboard/book">
                                    <FontAwesomeIcon icon={faShoppingCart} className="iconC" />
                                    Book Service
                                </NavLink>
                            </li>

                            <li>
                                <NavLink onClick={() => setTitle('Booking List')} className={navClass} to="/dashboard/booking">
                                    <FontAwesomeIcon icon={faList} className="iconC" />
                                    Booking List
                                </NavLink>
                            </li>

                            <li>
                                <NavLink onClick={() => setTitle('Review')} className={navClass} to="/dashboard/review">
                                    <FontAwesomeIcon icon={faCommentAlt} className="iconC" />
                                    Review
                                </NavLink>
                            </li>
                        </>
                    )}
                </ul>
            </nav>
        </div>
    );
};

export default Sidebar;